var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 71C55.1061 71 71 55.1061 71 35.5C71 15.8939 55.1061 0 35.5 0C15.8939 0 0 15.8939 0 35.5C0 55.1061 15.8939 71 35.5 71Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M6.20844 21.5152C6.08549 21.5152 5.96255 21.4845 5.87034 21.423C5.50151 21.2386 5.34783 20.7775 5.53224 20.378C11.2799 9.00567 22.7444 1.9364 35.4998 1.9364C37.5284 1.9364 39.5569 2.12081 41.5548 2.48964C41.9851 2.55112 42.2617 2.98143 42.1695 3.38099C42.108 3.8113 41.7084 4.08792 41.2781 3.99571C39.3725 3.65762 37.4361 3.4732 35.4998 3.4732C23.3591 3.4732 12.3864 10.2044 6.91536 21.0849C6.76168 21.3615 6.48506 21.5152 6.20844 21.5152Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.321 36.2712C66.321 19.6699 52.863 6.2118 36.2616 6.2118C19.6602 6.2118 6.20215 19.6699 6.20215 36.2712C6.20215 52.8726 19.6602 66.3307 36.2616 66.3307C52.863 66.3307 66.321 52.8726 66.321 36.2712Z",
    fill: "#FDCC06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3175 58.6134V55.3554C29.9058 55.2325 26.5249 54.4026 24.1582 53.3576C23.2976 52.9888 22.8673 52.0359 23.1132 51.1139L23.943 48.071C24.2504 46.9645 25.4491 46.3805 26.5249 46.8108C28.8915 47.7944 31.8422 48.5935 35.008 48.5935C38.2967 48.5935 40.7249 47.487 40.7249 45.2126C40.7249 43.1533 38.8192 41.9238 34.2703 40.6944C27.7543 38.9117 23.0824 36.084 23.0824 30.3364C23.0824 25.1727 26.8629 21.2078 33.4404 20.1628V16.9048C33.4404 15.8598 34.301 14.9991 35.3461 14.9991H37.2824C38.3275 14.9991 39.1881 15.8598 39.1881 16.9048V19.8554C42.3539 19.9784 44.6283 20.5316 46.4725 21.1463C47.3946 21.4844 47.9171 22.468 47.6712 23.4208L46.9028 26.2485C46.5954 27.3242 45.4582 27.939 44.3824 27.5394C42.692 26.8939 40.3253 26.2485 37.2517 26.2485C33.3482 26.2485 32.2417 27.8468 32.2417 29.3221C32.2417 31.1048 34.5777 32.3342 39.6491 33.871C46.872 36.0533 49.8842 39.0346 49.8842 44.4442C49.8842 49.3926 46.2266 53.8494 39.0959 54.9559V58.6134C39.0959 59.6585 38.2352 60.5191 37.1902 60.5191H35.2539C34.1781 60.5191 33.3175 59.6585 33.3175 58.6134Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 62.3403,
    y1: -5.052,
    x2: -83.3366,
    y2: 215.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 57.9944,
    y1: 1.25389,
    x2: -19.5757,
    y2: 131.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCC06"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/Coin.9c5767b542c5f4198f23e38c5f6a1ea4.svg";
export { ForwardRef as ReactComponent };